import orderThunks from './Order';

const thunks = [...orderThunks];

export default thunks;
